import { matchPredictedLineupsWidget } from '@sky-it-livedata/livedata-football-widgets';

export const CSS_PREFIX = 'ftbl__';
export const TABS_ITEM_CLASSNAME = 'teams-tabs__tabs';
const TITLE_H1 = 'c-section-title';
const ABSTRACT = 'c-article-abstract';

export const checkTabs = () => {
  // MUTATION OBSERVER to watch for SELECTED WEB COMPONENT to appear
  const observer: MutationObserver = new MutationObserver(() => {
    const menu: Element | null = document.querySelector(`.${CSS_PREFIX}${TABS_ITEM_CLASSNAME}`);
    if (menu) {
      observer.disconnect();
      switchTabs(menu);
    }
  });

  const elementMatchPredictedLineups: Element | null = document.querySelector(matchPredictedLineupsWidget.tag);
  if (elementMatchPredictedLineups) {
    observer.observe(elementMatchPredictedLineups, { childList: true });
  }
};

/**
 * Replaces a text in a string with a given character
 * @param selectedText Text to be modified
 * @param currentTeam Team name to be replaced
 * @param selectedTeam Team name to be replaced with
 * @returns string
 */
export const replaceInnerText = (selectedText: string, currentTeam: string, selectedTeam: string): string => {
  return selectedText.replace(currentTeam, selectedTeam);
};

/**
 * Changes the team name in the Title and Abstract of the page, when a tab is clicked
 */
export const switchTabs = (menu: Element): void => {
  const menuItems: HTMLCollection = menu.children;
  const homeTeamName: string | null = menuItems[0].getAttribute('data-team-name');
  const awayTeamName: string | null = menuItems[2].getAttribute('data-team-name');

  homeTeamName &&
    awayTeamName &&
    Array.from(menuItems).forEach((tab: Element, index: number) => {
      tabAddClickListener(tab, homeTeamName, awayTeamName, index);
    });
};

/**
 * Adds click listener to the tabs
 * @param tab Element to which the click listener will be added
 * @param homeTeam Home team
 * @param awayTeam Away team
 * @param index Tab index
 */
export const tabAddClickListener = (tab: Element, homeTeam: string, awayTeam: string, index: number): void => {
  tab.addEventListener('click', () => {
    modifyElement(homeTeam, awayTeam, index);
  });
};

/**
 * Modifies Abstract, Title and Title data attribute with given value
 * @param tab Element to which the click listener will be added
 * @param homeTeam Home team
 * @param awayTeam Away team
 * @param index Tab index
 */
const modifyElement = (homeTeam: string, awayTeam: string, index: number): void => {
  const abstract: HTMLElement | null = document.querySelector(`.${ABSTRACT} > p`);
  const title: HTMLElement | null = document.querySelector(`.${TITLE_H1}`);
  const titleAttribute: string | null | undefined = title?.getAttribute('data-shadow');

  if (abstract) {
    if (abstract.innerHTML.search(homeTeam) !== -1 && index === 2) {
      abstract.innerHTML = replaceInnerText(abstract.innerHTML, homeTeam, awayTeam);
    } else if (abstract.innerHTML.search(homeTeam) === -1 && index === 0) {
      abstract.innerHTML = replaceInnerText(abstract.innerHTML, awayTeam, homeTeam);
    }
  }

  if (title && titleAttribute) {
    if (title.innerHTML.search(homeTeam) !== -1 && index === 2) {
      title.innerHTML = replaceInnerText(title.innerHTML, homeTeam, awayTeam);
      title.setAttribute('data-shadow', replaceInnerText(titleAttribute, homeTeam, awayTeam));
    } else if (title.innerHTML.search(homeTeam) === -1 && index === 0) {
      title.innerHTML = replaceInnerText(title.innerHTML, awayTeam, homeTeam);
      title.setAttribute('data-shadow', replaceInnerText(titleAttribute, awayTeam, homeTeam));
    }
  }
};
